import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/increase-visiblity-poshmark';

export default function Example() {
  return (
    <>
      <Head>
        <title>Increasing Visibility on Poshmark</title>
        <meta
          name='description'
          content="Learn how you can make more conversions on your online selling business by increasing your closet and listing's visibility on Poshmark."
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/increase-visiblity-poshmark' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/increase-visiblity-poshmark' />
        <meta property='og:title' content='Increasing Visibility on Poshmark' />
        <meta
          property='og:description'
          content="Learn how you can make more conversions on your online selling business by increasing your closet and listing's visibility on Poshmark."
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
